<script>
	import collect from 'collect.js';
	import { jwt } from '@/Stores/Store.js';
	import { authenticated } from '@/Stores/AuthUserStore.js';
	import AuthUserStore from '@/Stores/AuthUserStore.js';
	import ACLStore from '@/Stores/ACLStore.js';
	import AlertStore from '@/Stores/AlertStore.js';
	import AdminUserStore from '@/Stores/AdminUserStore.js';
	import RoleStore from '@/Stores/RoleStore.js';
	import PermissionStore from '@/Stores/PermissionStore.js';
	import UserStore from '@/Stores/UserStore.js';
	import NoteStore from '@/Stores/User/NoteStore.js';
	import UserBetStatsStore from '@/Stores/User/UserBetStatsStore.js';
	import UserBoostStore from '@/Stores/UserBoostStore.js';
	import BetHistoryStore from '@/Stores/User/BetHistoryStore.js';
	import ExoticBetStore from '@/Stores/Racing/ExoticBetStore.js';
	import BonusBetStore from '@/Stores/User/BonusBetStore.js';
	import BetAdjustmentStore from '@/Stores/BetAdjustmentStore.js';
	import RuleStore from '@/Stores/RuleStore.js';
	import ReportStore from '@/Stores/ReportStore.js';
	import ReportOutputStore from '@/Stores/ReportOutputStore.js';
	import LinkGroupStore from '@/Stores/LinkGroupStore.js';
	import PreferenceStore from '@/Stores/PreferenceStore.js';
	import IncomingBetStore from '@/Stores/IncomingBetStore.js';
	import BetTickerStore from '@/Stores/BetTickerStore.js';
	import BetReviewPayoutStore from '@/Stores/BetReviewPayoutStore.js';
	import TrackStore from '@/Stores/Racing/TrackStore.js';
	import TrackBetTypeStore from '@/Stores/Racing/TrackBetTypeStore.js';
	import ClassificationStore from '@/Stores/Racing/ClassificationStore.js';
	import ClassificationBetTypeStore from '@/Stores/Racing/ClassificationBetTypeStore.js';
	import BetTypeStore from '@/Stores/Racing/BetTypeStore.js';
	import ProductStore from '@/Stores/Racing/ProductStore.js';
	import MeetingStore from '@/Stores/Racing/MeetingStore.js';
	import RaceStore from '@/Stores/Racing/RaceStore.js';
	import RaceBetTypeStore from '@/Stores/Racing/RaceBetTypeStore.js';
	import SelectionStore from '@/Stores/Racing/SelectionStore.js';
	import PriceStore from '@/Stores/Racing/PriceStore.js';
	import ResultStore from '@/Stores/Racing/ResultStore.js';
	import ManualResultStore from '@/Stores/Racing/ManualResultStore.js';
	import BetLegStore from '@/Stores/Racing/BetLegStore.js';
	import SportStore from '@/Stores/Sport/SportStore.js';
	import CompetitionStore from '@/Stores/Sport/CompetitionStore.js';
	import ParentMarketStore from '@/Stores/Sport/ParentMarketStore.js';
	import MarketGroupStore from '@/Stores/Sport/MarketGroupStore.js';
	import MarketGroupSetStore from '@/Stores/Sport/MarketGroupSetStore.js';
	import SportBetLegStore from '@/Stores/Sport/BetLegStore.js';
	import SportEventStore from '@/Stores/Sport/SportEventStore.js';
	import SportClassificationStore from '@/Stores/Sport/SportClassificationStore.js';
	import MarketTypeGroupStore from '@/Stores/Sport/MarketTypeGroupStore.js';
	import MarketStore from '@/Stores/Sport/MarketStore.js';
	import SportSelectionStore from '@/Stores/Sport/SportSelectionStore.js';
	import SportcastFixtureStore from '@/Stores/Sport/SportcastFixtureStore.js';

	if (!window.global) {
		window.global = {
			get authenticated() {
				return $authenticated && $authenticated;
			},
			get authuser() {
				return $AuthUserStore && $AuthUserStore;
			},
			get jwt() {
				return $jwt && $jwt;
			},
			store: {
				get acl() {
					return ACLStore && ACLStore;
				},
				get alerts() {
					return AlertStore && AlertStore;
				},
				get roles() {
					return RoleStore && RoleStore;
				},
				get permissions() {
					return PermissionStore && PermissionStore;
				},
				get adminusers() {
					return AdminUserStore && AdminUserStore;
				},
				get users() {
					return UserStore && UserStore;
				},
				get notes() {
					return NoteStore && NoteStore;
				},
				get userboosts() {
					return UserBoostStore && UserBoostStore;
				},
				get userbetstats() {
					return UserBetStatsStore && UserBetStatsStore;
				},
				get bethistory() {
					return BetHistoryStore && BetHistoryStore;
				},
				get exoticbets() {
					return ExoticBetStore && ExoticBetStore;
				},
				get bonusbets() {
					return BonusBetStore && BonusBetStore;
				},
				get betadjustment() {
					return BetAdjustmentStore && BetAdjustmentStore;
				},
				get rules() {
					return RuleStore && RuleStore;
				},
				get incomingbets() {
					return IncomingBetStore && IncomingBetStore;
				},
				get betticker() {
					return BetTickerStore && BetTickerStore;
				},
				get betpayoutreview() {
					return BetReviewPayoutStore && BetReviewPayoutStore;
				},
				get tracks() {
					return TrackStore && TrackStore;
				},
				get trackbettypes() {
					return TrackBetTypeStore && TrackBetTypeStore;
				},
				get classifications() {
					return ClassificationStore && ClassificationStore;
				},
				get classbettypes() {
					return ClassificationBetTypeStore && ClassificationBetTypeStore;
				},
				get bettypes() {
					return BetTypeStore && BetTypeStore;
				},
				get products() {
					return ProductStore && ProductStore;
				},
				get meetings() {
					return MeetingStore && MeetingStore;
				},
				get races() {
					return RaceStore && RaceStore;
				},
				get racebettypes() {
					return RaceBetTypeStore && RaceBetTypeStore;
				},
				get selections() {
					return SelectionStore && SelectionStore;
				},
				get prices() {
					return PriceStore && PriceStore;
				},
				get results() {
					return ResultStore && ResultStore;
				},
				// SPORT
				get sports() {
					return SportStore && SportStore;
				},
				get competitions() {
					return CompetitionStore && CompetitionStore;
				},
				get sportevents() {
					return SportEventStore && SportEventStore;
				},
				get parentmarkets() {
					return ParentMarketStore && ParentMarketStore;
				},
				get marketgroups() {
					return MarketGroupStore && MarketGroupStore;
				},
				get marketgroupsets() {
					return MarketGroupSetStore && MarketGroupSetStore;
				},
				get sportclassifications() {
					return SportClassificationStore && SportClassificationStore;
				},
				get sportcastfixtures() {
					return SportcastFixtureStore && SportcastFixtureStore;
				},
				// TODO: IS THIS NEEDED?
				get markettypegroups() {
					return MarketTypeGroupStore && MarketTypeGroupStore;
				},
				get markets() {
					return MarketStore && MarketStore;
				},
				get sportselections() {
					return SportSelectionStore && SportSelectionStore;
				},

				get manualresults() {
					return ManualResultStore && ManualResultStore;
				},
				get betlegs() {
					return BetLegStore && BetLegStore;
				},
				get sportbetlegs() {
					return SportBetLegStore && SportBetLegStore;
				},
				get preferences() {
					return PreferenceStore && PreferenceStore;
				},
				get reports() {
					return ReportStore && ReportStore;
				},
				get reportoutput() {
					return ReportOutputStore && ReportOutputStore;
				},
				get linkgroups() {
					return LinkGroupStore && LinkGroupStore;
				}
			},
			collection: {
				get acl() {
					return $ACLStore && $ACLStore;
				},
				get alerts() {
					return $AlertStore && $AlertStore;
				},
				get roles() {
					return $RoleStore && $RoleStore;
				},
				get permissions() {
					return $PermissionStore && $PermissionStore;
				},
				get adminusers() {
					return $AdminUserStore && $AdminUserStore;
				},
				get users() {
					return $UserStore && $UserStore;
				},
				get notes() {
					return $NoteStore && $NoteStore;
				},
				get userboosts() {
					return $UserBoostStore && $UserBoostStore;
				},
				get userbetstats() {
					return $UserBetStatsStore && $UserBetStatsStore;
				},
				get bethistory() {
					return $BetHistoryStore && $BetHistoryStore;
				},
				get exoticbets() {
					return $ExoticBetStore && $ExoticBetStore;
				},
				get bonusbets() {
					return $BonusBetStore && $BonusBetStore;
				},
				get betadjustment() {
					return $BetAdjustmentStore && $BetAdjustmentStore;
				},
				get rules() {
					return $RuleStore && $RuleStore;
				},
				get incomingbets() {
					return $IncomingBetStore && $IncomingBetStore;
				},
				get betticker() {
					return $BetTickerStore && $BetTickerStore;
				},
				get betpayoutreview() {
					return $BetReviewPayoutStore && $BetReviewPayoutStore;
				},
				// RACING
				get tracks() {
					return $TrackStore && $TrackStore;
				},
				get trackbettypes() {
					return $TrackBetTypeStore && $TrackBetTypeStore;
				},
				get classifications() {
					return $ClassificationStore && $ClassificationStore;
				},
				get classbettypes() {
					return $ClassificationBetTypeStore && $ClassificationBetTypeStore;
				},
				get bettypes() {
					return $BetTypeStore && $BetTypeStore;
				},
				get products() {
					return $ProductStore && $ProductStore;
				},
				get meetings() {
					return $MeetingStore && $MeetingStore;
				},
				get races() {
					return $RaceStore && $RaceStore;
				},
				get racebettypes() {
					return $RaceBetTypeStore && $RaceBetTypeStore;
				},
				get selections() {
					return $SelectionStore && $SelectionStore;
				},
				get prices() {
					return $PriceStore && $PriceStore;
				},
				get results() {
					return $ResultStore && $ResultStore;
				},
				// SPORT
				get sports() {
					return $SportStore && $SportStore;
				},
				get competitions() {
					return $CompetitionStore && $CompetitionStore;
				},
				get sportevents() {
					return $SportEventStore && $SportEventStore;
				},
				get parentmarkets() {
					return $ParentMarketStore && $ParentMarketStore;
				},
				get marketgroups() {
					return $MarketGroupStore && $MarketGroupStore;
				},
				get marketgroupsets() {
					return $MarketGroupSetStore && $MarketGroupSetStore;
				},
				get sportclassifications() {
					return $SportClassificationStore && $SportClassificationStore;
				},
				get sportcastfixtures() {
					return $SportcastFixtureStore && $SportcastFixtureStore;
				},
				// TODO: IS THIS NEEDED?
				get markettypegroups() {
					return $MarketTypeGroupStore && $MarketTypeGroupStore;
				},
				get markets() {
					return $MarketStore && $MarketStore;
				},
				get sportselections() {
					return $SportSelectionStore && $SportSelectionStore;
				},
				get sportbetlegs() {
					return $SportBetLegStore && $SportBetLegStore;
				},
				get manualresults() {
					return $ManualResultStore && $ManualResultStore;
				},
				get betlegs() {
					return $BetLegStore && $BetLegStore;
				},
				get preferences() {
					return $PreferenceStore && $PreferenceStore;
				},
				get reports() {
					return $ReportStore && $ReportStore;
				},
				get reportoutput() {
					return $ReportOutputStore && $ReportOutputStore;
				},
				get linkgroups() {
					return $LinkGroupStore && $LinkGroupStore;
				},
				// GENERAL
				get collect() {
					return collect;
				}
			}
		};
	}
</script>
